export const TILES_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

export const MAP_ATTRIBUTION = '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>';
